import { render, staticRenderFns } from "./CampaignsAll.vue?vue&type=template&id=bb89c646&scoped=true"
import script from "./CampaignsAll.vue?vue&type=script&lang=js"
export * from "./CampaignsAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb89c646",
  null
  
)

export default component.exports